import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { Col, FormGroup, Label, Row } from "reactstrap";
import swal from "sweetalert";
import { customMultiValue, customOption } from "../../constants/const";
import { encryptStorage } from "../../constants/EncryptStorage";
import { ApiFinance } from "../config/finance/ApiFinance";
import { GetLanguageString } from "../helper/Components";
import FundFilter from "../helper/SearchFilter/FundFilter";
import { isUsraRole } from "../helper/Method";
import SelectUnit from "../shared/SelectUnit";

const ManageIncomeFilters = ({ values, setValues, handleSubUnits }) => {
  const { t } = useTranslation();
  const unitTypeName = encryptStorage.getItem("unitTypeName");

  const [loading, setLoading] = useState({
    source: false,
  });
  const [financeCategories, setFinanceCategories] = useState([]);

  const handleFinanceCategoryChange = (val) => {
    setValues((prev) => ({
      ...prev,
      selectedFinanceCategories: val || [],
    }));
  };

  useEffect(() => {
    setLoading((prev) => ({ ...prev, source: true }));

    ApiFinance()
      .GetFinanceSubCategoriesListByType("income")
      .then((res) => {
        const filteredCategories = (res.data || []).filter((category) => {
          if (
            unitTypeName === "Tanzeem" &&
            (category.label1?.includes("tarbiati") ||
              category.label1?.includes("help_from_muqami_tanzeem"))
          ) {
            return false;
          }
          if (
            unitTypeName !== "Halqa" &&
            (category.label1?.toLowerCase().includes("maktaba") ||
              (category.label || category.name || category.category || "").toLowerCase().includes("maktaba"))
          ) {
            return false;
          }
          return true;
        });

        setFinanceCategories(filteredCategories);
      })
      .catch((err) => {
        console.error(err);
        swal({
          title: err,
          text: err.response?.data,
          icon: "error",
          buttons: "OK",
        });
      })
      .finally(() => setLoading((prev) => ({ ...prev, source: false })));
  }, [setValues, unitTypeName]);

  return (
    <>
      <Row>
        <SelectUnit
          values={values}
          setValues={setValues}
          unitId={values.unit.value}
          excludeUnitTypes={isUsraRole() ? [] : ["Usra", "UsraMuavin", "Munfarid"]}
        />
      </Row>
      <Row>
        <Col md="3">
          <FormGroup>
            <Label className="col-form-label">
              {<GetLanguageString props="funds_source" />}
            </Label>
            <Select
              components={{
                Option: customOption,
                MultiValue: customMultiValue,
              }}
              options={financeCategories}
              name="selectedFinanceCategories"
              value={values.selectedFinanceCategories}
              className="basic-multi-select no-drag"
              classNamePrefix="select"
              isLoading={loading.source}
              isDisabled={financeCategories.length === 0}
              isMulti
              onChange={handleFinanceCategoryChange}
              placeholder={t("member_select")}
            />
          </FormGroup>
        </Col>
        <Col md="3">
          <FormGroup>
            <Label className="col-form-label">
              {<GetLanguageString props="account_type" />}
            </Label>
            <Select
              options={[
                { value: "cash", label: t("cash_in_hand_account") || "Cash in Hand" },
                { value: "amanat", label: t("amanat_account") || "Amanat Account" }
              ]}
              value={values.accountType}
              isClearable
              className="basic-single no-drag"
              classNamePrefix="select"
              onChange={(val) => {
                setValues((prev) => ({
                  ...prev,
                  accountType: val,
                }));
              }}
              placeholder={t("member_select")}
            />
          </FormGroup>
        </Col>
      </Row>
      {/* Bank Account */}
      {/*   <Row><Col md="4">
              <FormGroup>
                <Label className="col-form-label">
                  <GetLanguageString props="fund_bank_account" />
                </Label>
                <Select
                  options={bankAccountList}
                  value={selectedBankAccount}
                  placeholder="Select bank account"
                  className="basic-single no-drag"
                  classNamePrefix="select"
                  onChange={(option) => {
                    setSelectedBankAccount(option);
                    setAccountType(resolveAccountType(option));
                    setValues((prev) => ({
                      ...prev,
                      bankAccountId: option ? option.value : 0,
                    }));
                  }}
                />
              </FormGroup>
            </Col> 
          </Row>*/}
      <Row>
        <FundFilter
          values={values}
          setValues={setValues}
          showFullDate={true}
        />
      </Row>
    </>
  );
};

export default ManageIncomeFilters;
